import type { Set } from '@wix/ambassador-members-v1-member/types';

export interface InitialDataRequest {
  viewedMemberId: string;
  currentMemberId: string | null;
  postsPerPage: number;
  language: string;
  fetchMemberFieldSet: Set;
  isRTL: boolean;
  isMultilingualEnabled: boolean;
  showAboutSection?: boolean;
  showCommentsStats?: boolean;
  showLikesReceivedStats?: boolean;
  showTopCommentsStats?: boolean;
  showBadgesSection?: boolean;
  showOverviewSection?: boolean;
  showBlogPostsSection?: boolean;
}

export enum ServerErrorCode {
  TooManyLinksInAbout = 'TOO_MANY_LINKS_IN_ABOUT',
  TextTooLongInAbout = 'TEXT_TOO_LONG_IN_ABOUT',
}
